
import _ from 'lodash'
import { mapGetters } from 'vuex'
import DownloadAgreementButton from './DownloadAgreementButton'
import { isGPOCustomer } from '~/helpers/user'

export default {
  name: 'TermsAndConditionsMenu',
  components: { DownloadAgreementButton },
  computed: {
    ...mapGetters('user', ['practiceLocation'])
  },
  data() {
    return {
      items: [
        { id: 1, title: 'Services', href: 'services' },
        { id: 2, title: 'Fees And Payment', href: 'fees-and-payment' },
        { id: 3, title: 'Membership Term', href: 'membership-term' },
        { id: 4, title: 'Monthly Guarantee', href: 'monthly-guarantee' },
        { id: 5, title: 'Authorization', href: 'authorization' },
        {
          id: 6,
          title: 'Rights You Grant to ZenOne',
          href: 'rights-you-grant-to-zenone',
        },
        { id: 7, title: 'Miscellaneous', href: 'miscellaneous' },
        {
          id: 8,
          title: 'Recurring Payment Authorization Form',
          href: 'recurring-payment-authorization-form',
        },
        {
          id: 9,
          title: 'Authorization to Release Account Information',
          href: 'authorization-to-release-account-information',
        },
      ],
    }
  },
  mounted() {
    if (isGPOCustomer(this.$store)) {
      this.items = _.filter(this.items, (item) => item.id !== 8)
    }
  }
}
